<template>
  <div
    class="modal fade"
    tabindex="-1"
    aria-hidden="true"
    id="add-userGroup-modal"
    ref="newTargetModalRef"
  >
    <div class="modal-dialog modal-dialog-centered mw-950px">
      <div class="modal-content rounded">
        <!--v-if-->
        <div class="modal-header">
          <h5 class="modal-title">
            {{
              userGroup.id === 0
                ? translate("userGroup_detail_title")
                : translate("userGroup_detail_title_update")
            }}
          </h5>
          <!--begin::Close-->
          <div
            class="btn btn-icon btn-sm btn-active-light-primary ms-2 text-dark"
            aria-label="Close"
            @click="cancelForm"
          >
            <i class="bi bi-x-lg"></i>
          </div>
          <!--end::Close-->
        </div>
        <div class="modal-body rounded p-0">
          <div>
            <div class="card">
              <div
                id="add-company"
                class="collapse show"
              >
                <!-- // ! Kullanıcı Grup Formu -->
                <Form
                  ref="refForm"
                  v-slot="{ errors }"
                  id="add-company-form"
                  class="form p-10 rounded-bottom"
                  @submit="onSubmit"
                  novalidate="novalidate"
                  :validation-schema="companyValidator"
                >
                  <!-- // ! Kullanıcı Grup Adı -->
                  <div class="row mb-4 d-flex">
                    <label class="col-lg-4 col-form-label required fw-bold fs-6"
                      >{{ translate("userGroup_detail_label_name") }}
                    </label>

                    <div class="col-lg-8 fv-row d-v-container">
                      <Field
                        name="groupName"
                        type="text"
                        :class="`form-control form-control-lg fw-bold fs-6 ${
                          userGroup.name === 0 ? 'text-gray-500' : 'text-dark'
                        } ${errors['groupName'] !== undefined ? 'v-invalid' : ''}`"
                        :placeholder="translate('userGroup_detail_label_name')"
                        v-model.trim="userGroup.name"
                      />

                      <div class="col-lg-8 fv-row d-v-container">
                        <div class="fv-plugins-message-container d-v-content">
                          <div class="fv-help-block ms-2 v-element">
                            <ErrorMessage name="groupName" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-8 fv-row mt-5">
                    <div class="form-check form-check-custom form-check-solid">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="check-remember-all"
                        v-model="checkAllItem"
                        @change="selectAll(e)"
                      />
                      <div class="d-flex flex-column position-relative w-100">
                        <label
                          class="form-check-label col-form-label fw-bold p-0"
                          for="check-remember-all"
                          >{{ t("userGroup_list_permission_all") }}</label
                        >
                      </div>
                    </div>
                  </div>

                  <!-- // ! Yetki Listesi -->
                  <div
                    class="row justify-content-start d-flex flex-wrap mt-10"
                    style="margin-left: 0px"
                  >
                    <div
                      v-for="(permission, index) in permissionList"
                      :key="index.Id"
                      class="col-3 form-check form-check-custom form-check-solid"
                    >
                      <div class="col d-flex mb-5 align-items-center">
                        <input
                          :checkAllItem="checkAllItem"
                          class="form-check-input"
                          type="checkbox"
                          :id="`role-${permission.Id}`"
                          v-model="permission.Selected"
                        />

                        <div class="d-flex flex-column">
                          <label
                            class="form-check-label col-form-label fw-bold p-0"
                            :for="`role-${permission.Id}`"
                            >{{ translate(permission.SystemName) }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-8 fv-row mt-20">
                    <div class="form-check form-check-custom form-check-solid">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="check-remember"
                        v-model="userGroup.active"
                      />
                      <div class="d-flex flex-column position-relative w-100">
                        <label
                          class="form-check-label col-form-label fw-bold p-0 mt-2"
                          for="check-remember"
                          style="margin-bottom: 15px"
                          >{{ translate("userGroup_detail_check_label") }}</label
                        ><label
                          class="form-check-label col-form-label fw-bold fs-7 p-0 text-gray-500"
                          for="check-remember"
                          style="position: absolute; margin-top: 20px"
                          >{{
                            translate("userGroup_detail_check_label_description")
                          }}</label
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-end p-0"
                    style="padding-top: 1.5rem !important"
                  >
                    <a
                      @click="cancelForm"
                      class="btn btn-white btn-active-light me-2 border btn-sm fs-6"
                    >
                      {{ translate("Cancel") }}</a
                    ><button
                      v-if="buttonShow"
                      type="submit"
                      class="btn btn-primary border btn-sm fs-6"
                      :disabled="loading"
                    >
                      <div
                        v-if="loading"
                        class="spinner-border spinner-border-sm mx-1"
                      ></div>
                      <span class="indicator-label">
                        {{ translate("Add") }}
                      </span>
                    </button>

                    <a
                      v-else
                      @click="updateItem"
                      :class="`btn btn-primary border btn-sm fs-6 ${
                        Object.keys(errors).length > 0 || loading ? 'disabled' : ''
                      }`"
                    >
                      <span class="indicator-label">
                        <div
                          v-if="loading"
                          class="spinner-border spinner-border-sm mx-1"
                        ></div>
                        <span class="indicator-label">
                          {{ translate("Save") }}
                        </span>
                      </span>
                    </a>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, reactive, ref, onMounted, defineEmits, defineProps, watch } from "vue";
import { useStore } from "vuex";
import * as Yup from "yup";
import { hideModal } from "@/core/helpers/dom";
import { useI18n } from "vue-i18n";

const newTargetModalRef = ref(null);
const refForm = ref(null);
const store = useStore();
const checkAllItem = ref(false);
const props = defineProps({ groupId: Number });
const emit = defineEmits(["cancelForm"]);
const block = ref(false);
const buttonShow = ref(true);
const loading = ref(false);

const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

watch(props, () => {
  if (props.groupId !== 0) {
    block.value = true;
    buttonShow.value = false;
    store.dispatch("UserRoleModule/GET_USERGROUPS", props.groupId).then((response) => {
      if (response !== null) {
        userGroup.name = response.Name;
        userGroup.id = response.Id;
        userGroup.active = response.Active;

        store.dispatch("UserRoleModule/GET_PERMISSIONS", userGroup.id);
        setTimeout(() => {
          block.value = false;
        }, 300);
      } else {
        cancelForm();
      }
    });
  } else {
    buttonShow.value = true;
  }
});

// Yetki Listesi
const permissionList = computed(() => store.getters["UserRoleModule/_getPermissions"]);

// Form Bilgileri
const userGroup = reactive({
  id: 0,
  name: null,
  permissions: [],
  active: true,
});

//Form Sayfasını komple gizleme methodu
const cancelForm = () => {
  hideModal(newTargetModalRef.value);
};

//Ekleme butonu
const onSubmit = (values, { resetForm }) => {
  loading.value = true;
  //Active olanların id leri permissions listesine eklendi
  userGroup.permissions = [];
  permissionList.value
    .filter((item) => item.Selected === true)
    .forEach((element) => {
      userGroup.permissions.push(element.Id);
    });

  //User Group Oluşturma
  store.dispatch("UserRoleModule/ADD_USERGROUPS", userGroup).then((response) => {
    loading.value = false;
  });

  cancelForm();
};

//validation
const companyValidator = Yup.object().shape({
  groupName: Yup.string().nullable().required(translate("userGroups_detail_Valid_Name")),
});
const updateItem = () => {
  loading.value = true;
  permissionList.value
    .filter((item) => item.Selected === true)
    .forEach((element) => {
      userGroup.permissions.push(element.Id);
    });
  store.dispatch("UserRoleModule/UPDATE_USERGROUPS", userGroup).then((response) => {
    if (response) {
      loading.value = false;
    } else {
      loading.value = false;
    }
  });

  cancelForm();
};

// ekleme yapıldığında formu temizleme methodu
const clearForm = () => {
  setTimeout(() => {
    userGroup.id = 0;
    userGroup.name = null;
    userGroup.active = true;
    checkAllItem.value = false;
    refForm.value.resetForm();
    emit("cancelForm");
  }, 300);
};

const selectAll = (e) => {
  if (checkAllItem.value && permissionList.value.length > 0) {
    permissionList.value.forEach((item) => (item.Selected = true));
  } else if (!checkAllItem.value && permissionList.value.length > 0) {
    permissionList.value.forEach((item) => (item.Selected = false));
  }
};

onMounted(() => {
  document
    .getElementById("add-userGroup-modal")
    .addEventListener("hide.bs.modal", function () {
      clearForm();
    });
});
</script>

<style></style>
